export const docgroupsReducer = (state:[], action:any) => {
    switch (action.type) {
        case 'SET_DOCGROUPS':
            state = action.payload;
            return state;
        default:
            return state || [];
    }
}

export const doctypesReducer = (state:[], action:any) => {
    switch (action.type) {
        case 'SET_DOCTYPES':
            state = action.payload;
            return state;
        default:
            return state || {};
    }
}

export const metatypesReducer = (state:{}, action:any) => {
    switch (action.type) {
        case 'SET_METATYPES':
            state = action.payload;
            return state;
        default:
            return state || {};
    }
}